import { PaintBrush, Sticker, Notebook, Tote, House, Tag, Heart, Star, Flower, Palette, Hoodie, Coffee } from "@phosphor-icons/react";

const ICON_MAP = {
  "paint-brush": PaintBrush,
  "sticker": Sticker,
  "notebook": Notebook,
  "tote": Tote,
  "house": House,
  "tag": Tag,
  "heart": Heart,
  "star": Star,
  "flower": Flower,
  "palette": Palette,
  "hoodie": Hoodie,
  "coffee": Coffee,
};

// Legacy name-based mapping for backwards compat
const CATEGORY_NAME_MAP = {
  "Art Prints": PaintBrush,
  "Stickers": Sticker,
  "Stationery": Notebook,
  "Accessories": Tote,
  "Home": House,
};

export function CategoryIcon({ category, iconName, size = 24, className = "" }) {
  // First try icon name (from DB), then fallback to category name mapping
  const Icon = (iconName && ICON_MAP[iconName]) || CATEGORY_NAME_MAP[category] || Tag;
  return <Icon size={size} weight="duotone" className={className} />;
}

export function getIconByName(iconName) {
  return ICON_MAP[iconName] || Tag;
}

export default ICON_MAP;
